import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../environments/environment';
import { DataService } from '../../../core/data/data-service';
import { PromoContentService } from '../../../core/routing/services/asset-library/promo-content.service';
import { GlobalConstants } from './../../../common/constants/global.constant';
import { CommonService } from './../../../common/services/common.service';
import { RouterConstants } from './../../../core/routing/constants/app-paths.constant';
import { Observable } from 'rxjs/internal/Observable';
import { CreatePromoContentResponse, PromoContent, PromoContentConfiguration, PromoContentGroupPage, PromoContentViewModel } from './interfaces/promo-content.i';
import { Utils } from '../../../common/utils/utils';
import { ProfileStoreService } from '../../create-profile/store/profile.store';
import { ProfileUpdateResponse, PromotionalContent } from '../../create-profile/interface/profile.i';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { SendToStoreService } from '../../../core/routing/services/asset-library/send-to-store.service';
import { LanguageConstants } from '../../header/constants/lang.consts';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PageComponent } from '../page/page.component';

@Component({
  selector: 'iposcen-promo-content',
  templateUrl: './promo-content.component.html',
  styleUrls: ['./promo-content.component.scss']
})
export class PromoContentComponent implements OnInit, OnDestroy {

  @ViewChild('deleteModal') deleteModal: ElementRef;
  @ViewChild('showModal') showModal: ElementRef;
  @ViewChild('applyModal') applyModal: ElementRef;
  @ViewChild('sendToAccountModal') sendToAccountModal: ElementRef;
  @ViewChild('page1') page1: PageComponent;
  @ViewChild('page2') page2: PageComponent;
  @ViewChild('page3') page3: PageComponent;
  @Input() enableAIIPOSPreview;
  @Output() readonly gotoBackCreateProfile = new EventEmitter<object>();
  whichPageDelete
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  userRole = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  retailHqUser = GlobalConstants.RETAIL_HQ_USER;
  regionalHqUser = GlobalConstants.REGIONALHQ;
  globConst = GlobalConstants;
  configurations: PromoContentConfiguration[];
  tabIndex = 0;
  checkIndex = 0;
  currentdetailPage: string;
  disabled: boolean;
  allPromoContentGroups: PromoContent[];
  displayPromoContentGroups = [];
  count$: Observable<number>;
  selectedFiles: FileList;
  sideNav = 'store';
  sortValue = GlobalConstants.CREATED_DATE;
  page = 1;
  pageSize = 5;
  maxSize = 5;
  lCGlayout = 1;
  promoCGToDelete: string;
  promoCGToDeleteName: string;
  contentGrpData: any;
  pageType = GlobalConstants.PROMO_CONTENT_GROUP;
  pages: any; // update the no of pages for edit.
  mediaObjects: any[] = [];
  editCheck: boolean;
  checkInd: number;
  checkInd2: number;
  presentPage: string;
  sendButtonText: string;
  promoContentIdInfo: string;
  sendNameToStore: string;
  retailHQUser: string;
  isRetailerUser: boolean;
  isSendToStore = false;
  details: string = ' Details';
  profilePage: string = GlobalConstants.PROFILE;
  assetsPage: string = GlobalConstants.ASSET_LIBRARY;
  clickable = false; // This is to enable tabs click only after clicking on Save & Proceed.TODO: will remove this later.
  showPromoContentName: string; // To Show logocontentname as tab title.
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  pageGrpForm: any;
  buttonName: string;
  showDevice = false;
  isNavigated = false;
  newContentGrpDataToNavigate: any;
  newPromoContentTitle: string = $localize`:@@promo-content.tab-pane.new-promo-content-group:NEW PROMOTIONAL CONTENT GROUP`;
  addUptoTenPromoDescription: string = $localize`:@@promo-content.add-upto-10-desc:You may show 3 Promotional Content groups, and add up to 6.`;
  noPromoCreatedDescription: string = $localize`:@@promo-content.no-promo-desc:No Promotional Content Group has been created.`;
  yesLabel: string = GlobalConstants.YES;
  noLabel: string = GlobalConstants.NO;
  deviceTypes = GlobalConstants.DEVICE_TYPES;
  manufacturers = GlobalConstants.MANUFACTURERS;
  processors = GlobalConstants.PROCESSORS;
  generation = GlobalConstants.GENERATION;
  showonDeviceDisabled = GlobalConstants.SHOW_ON_DEVICE_DISABLED;
  showonDeviceLimit = GlobalConstants.SHOW_ON_DEVICE_LIMIT;
  addToPackageLimit = GlobalConstants.ADD_TO_PACKAGE_LIMIT;
  tooltipEdit = GlobalConstants.EDIT;
  tooltipDelete = GlobalConstants.DELETE;
  tooltipSend = GlobalConstants.OPTIONAL_TOOLTIP;
  contentGrpText = GlobalConstants.CONTENT_GROUP;
  lockContentText = GlobalConstants.CONTENT_LOCKED;
  isStoreUser: boolean;
  isRegionalHQ: boolean;
  selctedContGrpsForProfile: any = {
    contentGrps: [],
    showOnDevice: []
  };
  isPage3Created: boolean;
  profileDataResponse: ProfileUpdateResponse;
  promoContentLabel = GlobalConstants.PROMO_CONTENT_GROUP_TEXT;
  createdDateVal = GlobalConstants.CREATED_DATE;
  groupNameVal = GlobalConstants.GROUP_NAME;
  changePlacement: boolean;
  retailerUserId = sessionStorage.getItem('retailerId');
  private ngUnsubscribe = new Subject<boolean>();
  pageError = new Map([[1, false], [2, false], [3, false]]);
  buttonLable = GlobalConstants.OK_BUTTON;
  errorMessageText = GlobalConstants.PAGE_ERROR_MESSAGE;
  errorMessageText1 = GlobalConstants.PAGE_ERROR_MESSAGE1;
  errorMessageText2 = GlobalConstants.PAGE_ERROR_MESSAGE2;
  errorMessageText3 = GlobalConstants.PAGE_ERROR_MESSAGE3;
  errorMessageText4 = GlobalConstants.PAGE_ERROR_MESSAGE4;
  errorMessageText5 = GlobalConstants.PAGE_ERROR_MESSAGE5;
  errorMessageText6 = GlobalConstants.PAGE_ERROR_MESSAGE6;
  profileNameValue = GlobalConstants.PROFILE_NAME_LOWER_CASE;
  internalName = GlobalConstants.INTERNAL_NAME;
  deviceExists: boolean;
  pagelen: number;
  previewType:string;
  isIdleExperienceEnabled:string = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
  isCheckedPreview: boolean;
  showPreviewLayout: boolean;
  previewTabs = ["Panther", "Lunar","CoreUltra", "CoreProcessor", "Evo"];
  activePreviewTab : string = 'Panther';
  previousSelectedTab : string = '';

  constructor(
    private router: Router,
    private cmnService: CommonService,
    private promoContentService: PromoContentService,
    private profileStoreService: ProfileStoreService,
    private dataService: DataService,
    private createProfileService: CreateProfileService,
    private sendToStoreService: SendToStoreService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.promoContentIdInfo = '';
    this.isCheckedPreview = true;
    if (this.isArabic || this.isHebrew) {
      this.changePlacement = true;
    }
    if (this.profileStoreService.currentWorkingProfile) {
      this.profileDataResponse = JSON.parse(JSON.stringify(this.profileStoreService.currentWorkingProfile));
    }
    this.cmnService.pageObser
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data) => {
      if(data.media.format === 'video/mp4' && ((data.previewType === GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS && data.fullScreenCheckbox) || (data.previewType === GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE && data.idleExpFullscreenEnabled))) {
        this.showPreviewLayout = false;
      } else {
        this.showPreviewLayout = true;
      }
    });
    this.retailHQUser = sessionStorage.getItem('userRole');
    this.isRetailerUser = (this.retailHQUser === 'retailHQUser') || false;
    this.isRegionalHQ = (this.retailHQUser === 'regionalHQ') || false;
    this.isStoreUser = (sessionStorage.getItem(GlobalConstants.USER_ROLE) === GlobalConstants.STORE_USER) || false;
    // if user in profile and going to promo content group tab -> refresh this.selctedContGrpsForProfile
    this.getAllPromoContentsByUser();
    this.pages = {};
    this.disabled = true;
    this.editCheck = false;
    this.currentdetailPage = this.router.url;
    // set presentpage
    const pageName = this.currentdetailPage.lastIndexOf('/');
    if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.ASSET_LIBRARY) {
      this.presentPage = GlobalConstants.ASSET_LIBRARY;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE ||
      this.currentdetailPage.includes(RouterConstants.EDIT_PROFILE)) {
      this.presentPage = GlobalConstants.PROFILE;
    }
    // else
    this.cmnService.pageDataTologoObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => { });

    // dummy data to preview page
    this.cmnService.pageDataTologoObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        // console.log(res);
        // pages data. To-Do: update to common object ;
        // const updatePromoContent: CreatePromoContentResponse = this.contentGrpData as CreatePromoContentResponse;
        // Once page is updated.
        const promoContent = this.contentGrpData.promotionalContent;
        const configurations = promoContent.configurations;
        if (res.data.media.url !== '') {
          this.prepareMediaSet(res, promoContent.id);
        }
        const checkJson = this.checkExistance(configurations.contentGroupPages, 'pageNum', res.number);
        if (checkJson.hasMatch) {// If there is configuration object already for the page number
          // Update the pages
          configurations.contentGroupPages[checkJson.matchedIndex] = {
            pageNum: res.number,
            title: res.data.heading,
            titleFontColor: res.data.hcolor,
            bgColor: res.data.bgcolor,
            bodyCopy: res.data.body,
            bodyCopyFontSize: this.fontSizeNumber(res.data.size),
            bodyCopyFontColor: res.data.bcolor,
            UiLayout: this.getUILayoutNameByID(res.data.layout),
            linkedAsset: res.data.media.url !== '' ? true : false,
            linkedAssetFileType: res.data.media.format,
            fileName: res.data.media.name,
            previewType: res.data.previewType,
            idleExpFullscreenEnabled: res.data.idleExpFullscreenEnabled,
            fullScreenCheckbox: res.data.fullScreenCheckbox,
          };
        } else {
          const promoContentGroupPage: PromoContentGroupPage = {
            pageNum: res.number,
            title: res.data.heading,
            titleFontColor: res.data.hcolor,
            bgColor: res.data.bgcolor,
            bodyCopy: res.data.body,
            bodyCopyFontSize: this.fontSizeNumber(res.data.size),
            bodyCopyFontColor: res.data.bcolor,
            UiLayout: this.getUILayoutNameByID(res.data.layout),
            linkedAsset: res.data.media.url !== '' ? true : false,
            linkedAssetFileType: res.data.media.format,
            fileName: res.data.media.name,
            previewType: res.data.previewType,
            idleExpFullscreenEnabled: res.data.idleExpFullscreenEnabled,
            fullScreenCheckbox: res.data.fullScreenCheckbox,
          };
          configurations.contentGroupPages.push(promoContentGroupPage);
        }
        this.contentGrpData.promotionalContent = promoContent;
      });
  }
  openPopup(modal) {
    this.modalService.open(modal);
  }
  getPageError(data) {
    this.pageError.set(data[1], data[0])
  }
  resetPage() {
    this.pageError = new Map([[1, false], [2, false], [3, false]]);
  }
  goToErrorPage() {
    if (this.pageError.get(1) === true) {
      this.tabIndex = 2
    } else if (this.pageError.get(2) === true) {
      this.tabIndex = 3
    } else {
      this.tabIndex = 4
    }
  }
  checkExistance(data, key, compValue) {
    const checkJSON = { hasMatch: false, matchedIndex: -1 };
    for (let index = 0; index < data.length; index += 1) {
      if (data[index][key] === compValue) {
        checkJSON.hasMatch = true;
        checkJSON.matchedIndex = index;
        break;
      }
    }

    return checkJSON;
  }

  // minipreview image or video content
  loadMiniPreview(gId: string, pageContent: any) {
    this.pageGrpForm = {
      bgcolor: pageContent ? pageContent.bgColor : '#0068B5',
      heading: pageContent ? pageContent.title : '',
      hcolor: pageContent ? pageContent.titleFontColor : '#ffffff',
      body: pageContent ? pageContent.bodyCopy : '',
      bcolor: pageContent ? pageContent.bodyCopyFontColor : '#ffffff',
      size: pageContent ? this.getFontSize(pageContent.bodyCopyFontSize) : GlobalConstants.MEDIUM,
      media: {
        url: (pageContent && pageContent.linkedAsset) ?
          environment.apiBaseUrlAsset + this.url +
          AssetLibraryConstants.PROMO_CONTENTS +
          AssetLibraryConstants.SLASH + gId +
          AssetLibraryConstants.SLASH + pageContent.pageNum.toString() : '',
        name: '',
        format: (pageContent && pageContent.linkedAsset) ? (pageContent.linkedAssetFileType) ? pageContent.linkedAssetFileType : '' : '',
        fileObj: ''
      },
      id: gId,    // adding created group id,
      layout: pageContent ? this.getUILayoutIDByName(pageContent.UiLayout) : 1,
      previewType: pageContent ? pageContent.previewType : '',
      idleExpFullscreenEnabled: pageContent ? pageContent.idleExpFullscreenEnabled : '',
      fullScreenCheckbox: pageContent ? pageContent?.fullScreenCheckbox ? 
      pageContent.fullScreenCheckbox : false : true,
    };

    return this.pageGrpForm;
  }
  getFontSize(size: number) {
    if (size === GlobalConstants.NUMBER_12) { return GlobalConstants.SMALL; }
    if (size === GlobalConstants.NUMBER_14) { return GlobalConstants.MEDIUM; }
    if (size === GlobalConstants.NUMBER_16) { return GlobalConstants.LARGE; }
  }
  getUILayoutIDByName(name: string) {
    if (name === GlobalConstants.TWO_COL_RIGHT_ASSET) {
      return 1;
    } else if (name === GlobalConstants.TWO_COL_LEFT_ASSET) {
      return 2;
    } else if (name === GlobalConstants.ONE_COL_MID_ASSET) {
      return 3;
    }
  }

  // To hold all pages media objects and its metada.
  prepareMediaSet(res: any, promoContentId: string) {
    const checkJson = this.checkExistance(this.mediaObjects, 'pageNum', res.number);
    if (checkJson.hasMatch) {
      // Update the pages
      this.mediaObjects[checkJson.matchedIndex] = {
        id: promoContentId,
        media: res.data.media,
        pageNum: res.number
      };
      if (typeof res.data.media.fileObj === 'object' && res.data.media.fileObj) {
        this.mediaObjects[checkJson.matchedIndex].uploaded = true;
      }
    } else {
      const dataObj: any = {
        id: promoContentId,
        media: res.data.media,
        pageNum: res.number
      };
      if (typeof res.data.media.fileObj === 'object' && res.data.media.fileObj) {
        dataObj.uploaded = true;
      }
      this.mediaObjects.push(dataObj);
    }
    // console.log(this.mediaObjects);
  }

  setSideNav(value: string) {
    this.sideNav = value;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getAllPromoContentsByUser() {
    this.editCheck = false;
    this.promoContentService.getAllPromoContentByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllPromoContentResponse => {
        this.allPromoContentGroups = (getAllPromoContentResponse.promotionalContent as PromoContent[]);
        this.configurations = [];
        this.allPromoContentGroups.forEach(promoContentGroup => {
          try {
            this.configurations.push(JSON.parse(promoContentGroup.configurations) as PromoContentConfiguration);
          }
          catch (err) {
            console.log(err);
          }
        });
        // display Promo content groups using displayPromocontentgroups var as configurations is coming as string
        this.displayPromoContentGroups = [];
        this.allPromoContentGroups.forEach(ele => {
          try {
            ele.configurations = JSON.parse(ele.configurations);
          }
          catch (err) {
            console.log(err);
          }
          ele.createdByUser = (ele.createdByUser === this.userId) ? GlobalConstants.ME : ele.createdByUser;
          this.displayPromoContentGroups.push(ele);
        });
        this.displayPromoContentGroups.forEach(element => {
          // adding this custom property to know which Promo content is expanded
          // console.log('display promo content group:: ' + JSON.stringify(element));
          element.isExpanded = false;
          element.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
          if (element.updateTime) {
            element.updateTime = new Date(element.updateTime);
            element.updateTimeDisplay = new Date(element.updateTime).toLocaleString()
              .replace(',', '');
          }
          if (element && element.configurations && element.configurations.formFactor) {
            element.configurations.formFactor = Utils.getFormFactorNames(element.configurations.formFactor);
          }
          // converting date format:
          if (element && element.configurations) {
            if (element.configurations?.publishTime && !element.configurations.isPublishDateNow) {
              //changing it to old format
              element.configurations.publishTime = Utils.ChangetoOldFormat(element.configurations.publishTime);
            }
            if (element.configurations.expireTime && element.configurations.expireTime !== GlobalConstants.NEVER) {
              //changing it to old format
              element.configurations.expireTime = Utils.ChangetoOldFormat(element.configurations.expireTime);
            }
            if (element.configurations.expireTime && element.configurations.expireTime === GlobalConstants.NEVER) {
              element.configurations.expireTime = LanguageConstants.NEVER;
            }
          }
          // converting date for display purpose:
          if ((this.presentPage === this.profilePage)) {
            element.showOnDevice = false;
            element.addToPackage = false;
          }
          // For content expired notification
          element.isContentExpires = Utils.getExpiredContentdata(element);
        });

        this.sortByDate();
        if (this.presentPage === this.profilePage) {
          this.displayPromoContentGroups.forEach((element, index) => {
            element.index = index;
          });
          // for edit profile - promo content tab
          this.profileDataResponse = JSON.parse(JSON.stringify(this.profileStoreService.currentWorkingProfile));
          if (this.profileDataResponse?.promotionalContents &&
            (this.profileDataResponse?.profileId === this.createProfileService.getProfileId())) {
            this.selctedContGrpsForProfile = {
              contentGrps: [],
              showOnDevice: []
            };
            this.displayPromoContentGroups.forEach(a => a.showOnDevice = a.addToPackage = false);
            if (this.profileDataResponse?.promotionalContents?.length === 1 && !this.profileDataResponse?.promotionalContents[0].showOnDevice && this.profileDataResponse?.promotionalContents[0].promotionalContentId === undefined) {
              this.selctedContGrpsForProfile.contentGrps = [];
            } else {
              this.selctedContGrpsForProfile.contentGrps = this.profileDataResponse.promotionalContents;
            }
            this.selctedContGrpsForProfile.contentGrps.forEach((ele, ind) => {
              const contentIdInd = this.displayPromoContentGroups.findIndex(each => each.id === ele.promotionalContentId);
              if (contentIdInd >= 0) {
                this.displayPromoContentGroups[contentIdInd].addToPackage = true;
                this.displayPromoContentGroups[contentIdInd].showOnDevice = ele.showOnDevice;
                if (ele.showOnDevice) {
                  this.selctedContGrpsForProfile.showOnDevice.push(this.displayPromoContentGroups[contentIdInd].id);
                }
              }
            });
          }
        }

        if (this.showDevice) {
          if (this.selctedContGrpsForProfile.showOnDevice.length === 3) {
            const elementShowOnDevice = this.displayPromoContentGroups.filter(d => d.showOnDevice === true)
              .sort((bc1, bc2) => new Date(bc1.updateTime)?.getTime() - new Date(bc2.updateTime)?.getTime())[0];
            this.displayPromoContentGroups.filter(x => x.id === elementShowOnDevice.id)[0].showOnDevice = false;
            this.selctedContGrpsForProfile.showOnDevice = this.selctedContGrpsForProfile.showOnDevice
              .filter(item => item !== elementShowOnDevice.id);
            this.selctedContGrpsForProfile.contentGrps
              .filter(x => x.promotionalContentId === elementShowOnDevice.id)[0].showOnDevice = false;
          }
          if (this.selctedContGrpsForProfile.contentGrps.length === 6) {
            const element = this.displayPromoContentGroups.filter(d => d.addToPackage === true)
              .sort((bc1, bc2) => new Date(bc1.updateTime)?.getTime() - new Date(bc2.updateTime)?.getTime())[0];
            this.selctedContGrpsForProfile.contentGrps = this.selctedContGrpsForProfile.contentGrps
              .filter(x => x.promotionalContentId !== element.id);
            this.displayPromoContentGroups.filter(x => x.id === element.id)[0].addToPackage = false;
          }
          this.displayPromoContentGroups[0].addToPackage = true;
          this.displayPromoContentGroups[0].showOnDevice = true;
          this.pushToSelectedGrps(0);
          this.selctedContGrpsForProfile.showOnDevice.push(this.displayPromoContentGroups[0].id);

          const promoContentData: PromotionalContent = this.selctedContGrpsForProfile.contentGrps as PromotionalContent;
          this.createProfileService.updateProfile(this.createProfileService.getProfileId(), { promotionalContents: promoContentData })
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
              const profileUpdateResponse = data.profile as ProfileUpdateResponse;
              this.profileStoreService.updateProfileData(profileUpdateResponse);
            });
        }

      },
        error => {
          // do something
        });
  }

  changeLockContentStatus(id: string, eventObj: any, object: []) {
    const status = eventObj.target.checked ? GlobalConstants.LOCK_CONTENT_LOCK : GlobalConstants.LOCK_CONTENT_UNLOCK;
    this.cmnService.changeLockContentStatus(id, status, AssetLibraryConstants.PROMO_CONTENTS)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(response => {
        this.displayPromoContentGroups[this.displayPromoContentGroups.indexOf(object)].islocked = eventObj.target.checked;
      });
  }

  cancel() {
    this.dataService.setPromoContent(undefined);
    if (this.contentGrpData) {
      for (let each of this.displayPromoContentGroups) {
        if (each.id === this.contentGrpData.promotionalContent.id) {
          if (typeof each.configurations === 'string') {
            each.configurations = JSON.parse(each.configurations);
          }
          break;
        }
      }
    }
    this.getAllPromoContentsByUser();
    this.setIndex(0);
    this.mediaObjects = [];
    this.pages = {};
    this.clickable = false;
    this.editCheck = false;
  }

  setCreatedGrpID(data) {
    this.buttonName = this.promoContentService.buttonName;

    if (typeof data === 'object' && data.cancel) {
      this.setIndex(0);
      this.pages = {};
      this.editCheck = false;
    } else {
      this.selctedContGrpsForProfile = {
        contentGrps: [],
        showOnDevice: []
      };
      this.page = 1; // set pagination to 1
      this.pages.page1 = true;
      this.isPage3Created = this.checkPages();
      this.contentGrpData = data;
      if (typeof this.contentGrpData.promotionalContent.configurations === 'string') {
        this.contentGrpData.promotionalContent.configurations =
          JSON.parse(this.contentGrpData.promotionalContent.configurations) as PromoContentConfiguration;
      }
      this.showPromoContentName = this.contentGrpData.promotionalContent.configurations.publishedName;
      this.clickable = true;
      this.setIndex(2);
    }
    // this.mediaObjects = [];
  }
  /*when user opens pages*/
  setPreviewLayout(data) {
    this.lCGlayout = data;
  }
  /*when users slects layout*/
  setIndex(value: number) {
    this.tabIndex = value;

  }

  createPromo() {
    this.mediaObjects = [];
    this.dataService.setPromoContent(undefined);
    this.tabIndex = 1;
  }

  setLayout(selected) {
    this.lCGlayout = selected;
    this.cmnService.emitLayout(selected);
  }

  refreshPromoContentdata() {
    // console.log('inside refreshPromoContentdata');
    this.getAllPromoContentsByUser();
    this.setIndex(0);
    this.mediaObjects = [];
  }

  redirectToLogin() {
    this.router.navigateByUrl(RouterConstants.LOGIN_PAGE_LINK);
  }

  trackByConfiguration(index: number, el: string): number {
    return index;
  }

  // get details of Promo content by id when click on arrow besides particular Promo content group
  getPromoContentDetails(id: string) {
    // TODO check with Sujay or Magesh to fetch the id of existing Promo  - first ngfor if i can change
    this.promoContentService.getPromoContentById(id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getPromoContentById => {
        const promoContentGrpdetails = (getPromoContentById.PromoContent as PromoContent[]);
        // console.log('promoContentGrpdetails--', promoContentGrpdetails);
      },
        error => {
          // do something
        });
  }

  getDetailsOfPromoCG(id: string) {
    this.displayPromoContentGroups.forEach(element => {
      if (element.id === id) {
        element.isExpanded = !element.isExpanded;
        element.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
        this.cmnService.scrollToBottom(id);
      }
    });
    this.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
  }

  sortByDate() {
    this.page = 1;
    this.sortValue = GlobalConstants.CREATED_DATE;
    // this.displayPromoContentGroups.sort((promo1, promo2) => promo2.updateTime
    //   .localeCompare(promo1.updateTime));
    this.displayPromoContentGroups.sort((promo1, promo2) => promo2.updateTime - promo1.updateTime);
  }

  sortByName() {
    this.page = 1;
    this.sortValue = GlobalConstants.GROUP_NAME;
    this.displayPromoContentGroups.sort((promo1, promo2) =>
      promo1.configurations.publishedName.localeCompare(promo2.configurations.publishedName));
  }

  openPopupPromo(modal, pageNumber) {
    this.modalService.open(modal);
    this.whichPageDelete = pageNumber;
  }

  deletePages(which) {
    this.isPage3Created = false;
    let pagesLen = Object.entries(this.pages).length;
    this.pagelen = Object.entries(this.pages).length;
    if (pagesLen > 1) {
      delete this.pages["page" + (pagesLen)];
      this.pagelen -= 1;
    } else {
      this.page1.updated(undefined,undefined,'',1);
    }
    let configurations;
    let updatedPages = [];
    
    if (typeof this.contentGrpData.promotionalContent.configurations === 'string') {
      configurations = JSON.parse(this.contentGrpData.promotionalContent.configurations) as PromoContentConfiguration;
    } else {
      configurations = this.contentGrpData.promotionalContent.configurations as PromoContentConfiguration;
    }
    configurations.contentGroupPages.splice(which, 1);
    configurations.contentGroupPages.forEach((e, i) => {
      e.pageNum = i + 1;
      updatedPages.push(e);
    });

    if (this.page1) {
      this.page1.updated(configurations,AssetLibraryConstants.PROMO_CONTENTS ,'promo');
    } else if (this.page2) {
      this.page2.updated(configurations,AssetLibraryConstants.PROMO_CONTENTS ,'promo');
    } else {
      this.page3.updated(configurations,AssetLibraryConstants.PROMO_CONTENTS ,'promo');
    }
    configurations.contentGroupPages.forEach((e, i) => {
      if (which === 0) {
        this.setIndex(2)
      } else {
        this.setIndex(which + 1);
      }
    });
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openDeleteModal(promoCGID: string) {
    this.promoCGToDelete = this.displayPromoContentGroups.find(ele => ele.id === promoCGID).id;
    this.promoCGToDeleteName = this.displayPromoContentGroups.find(ele => ele.id === promoCGID).configurations.publishedName;
    this.openModal(this.deleteModal);
  }

  openSendPromoContentToAccountModal(promoCGID: string) {
    this.sendButtonText = GlobalConstants.PROMO_BUTTON_TEXT;
    this.promoContentIdInfo = promoCGID;
    this.sendNameToStore = this.displayPromoContentGroups.find(ele => ele.id === promoCGID).configurations.publishedName;
    this.openModal(this.sendToAccountModal);
  }

  editPromo(promoCGID: string) {
    this.pages = {};
    this.mediaObjects = [];
    const promoCGToEdit = this.displayPromoContentGroups.find(ele => ele.id === promoCGID);
    this.dataService.setPromoContent(promoCGToEdit);
    this.editCheck = true;
    for (let each of promoCGToEdit.configurations.contentGroupPages) {
      if (each.pageNum === 1) {
        this.pages.page1 = true;
      }
      if (each.pageNum === 2) {
        this.pages.page2 = true;
      }
      if (each.pageNum === 3) {
        this.pages.page3 = true;
      }
    }
    const tempPromoCont = promoCGToEdit as PromoContent;
    this.pagelen = Object.entries(this.pages).length;
    this.contentGrpData = {
      promotionalContent: tempPromoCont,
      responseContext: {}
    }; // set data to cntGrpData to show in pages
    this.showPromoContentName = promoCGToEdit.configurations.publishedName;
    this.setIndex(1);
  }

  duplicateAndEditPromoContent(promoCGID: string) {
    const promoContentToEdit = this.displayPromoContentGroups.find(ele => ele.id === promoCGID);
    const promoContentConfig = promoContentToEdit.configurations;
    if (promoContentConfig?.publishTime && !promoContentConfig?.isPublishDateNow) {
      //changing it to new format
      promoContentConfig.publishTime = Utils.changeSaveDateFormat(promoContentConfig?.publishTime);

    }
    if (promoContentConfig?.expireTime && promoContentConfig?.expireTime !== GlobalConstants.NEVER) {
      //changing it to new format
      promoContentConfig.expireTime = Utils.changeSaveDateFormat(promoContentConfig?.expireTime);

    }
    const promoContent: PromoContentConfiguration = {
      publishedName: `Copy of ${promoContentConfig.publishedName}`,
      internalName: promoContentConfig.internalName,
      publishTime: promoContentConfig.publishTime ? promoContentConfig.publishTime : new Date().toString(),
      expireTime: promoContentConfig.expireTime ? promoContentConfig.expireTime : GlobalConstants.NEVER,
      contentScheduleTimezoneCode: promoContentConfig.contentScheduleTimezoneCode,
      type: GlobalConstants.PROMO_CONTENT_GROUP,
      contentGroupPages: promoContentConfig.contentGroupPages,
      formFactor: promoContentConfig.formFactor,
      isPublishDateNow: promoContentConfig.isPublishDateNow,
      isPublishExpiryNever: promoContentConfig.isPublishExpiryNever
    };
    this.promoContentService.createPromoContent(JSON.stringify(promoContent))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async createPromoContentResponse => {
        this.getDetailsOfPromoCG(promoCGID);
        const createPromoContentResponseObj: CreatePromoContentResponse = createPromoContentResponse as CreatePromoContentResponse;
        const promoContentViewModel: PromoContentViewModel =
          createPromoContentResponseObj.promotionalContent as unknown as PromoContentViewModel;
        promoContentViewModel.configurations =
          JSON.parse(createPromoContentResponseObj.promotionalContent.configurations) as PromoContentConfiguration;
        if (promoContentToEdit?.configurations && promoContentToEdit.configurations.contentGroupPages?.length) {
          for (let page of promoContentToEdit.configurations.contentGroupPages) {
            // Loop and duplicate images
            await this.duplicatePromoContentImage(promoContentToEdit, promoContentViewModel, page);
          }
        }
        if (promoContentViewModel && promoContentViewModel.configurations) {
          if (promoContentViewModel.configurations?.publishTime && !promoContentViewModel.configurations.isPublishDateNow) {
            //changing it to old format
            promoContentViewModel.configurations.publishTime = Utils.ChangetoOldFormat(promoContentViewModel.configurations.publishTime);
          }
          if (promoContentViewModel.configurations.expireTime && promoContentViewModel.configurations.expireTime !== GlobalConstants.NEVER) {
            //changing it to old format
            promoContentViewModel.configurations.expireTime = Utils.ChangetoOldFormat(promoContentViewModel.configurations.expireTime);
          }
        }
        this.dataService.setPromoContent(promoContentViewModel);
        this.editCheck = true;
        for (let each of promoContentViewModel.configurations.contentGroupPages) {
          if (each.pageNum === 1) {
            this.pages.page1 = true;
          }
          if (each.pageNum === 2) {
            this.pages.page2 = true;
          }
          if (each.pageNum === 3) {
            this.pages.page3 = true;
          }
        }
        this.contentGrpData = {
          promotionalContent: promoContentViewModel,
          responseContext: {}
        }; // set data to cntGrpData to show in pages
        const tempViewModel: any = promoContentViewModel;
        /*dummy instance to add all required  flags for expand,delete,sort by date&time format*/
        tempViewModel.createdByUser = (tempViewModel.createdByUser === this.userId) ? GlobalConstants.ME : tempViewModel.createdByUser;
        tempViewModel.isExpanded = false;
        tempViewModel.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
        if (tempViewModel.updateTime) {
          tempViewModel.updateTime = new Date(tempViewModel.updateTime);
          tempViewModel.updateTimeDisplay = new Date(tempViewModel.updateTime).toLocaleString()
            .replace(',', '');
        }
        tempViewModel.addToPackage = tempViewModel.showOnDevice = false;
        this.displayPromoContentGroups.unshift(tempViewModel);
        if (this.presentPage === this.profilePage) {
          this.displayPromoContentGroups.forEach((element, index) => {
            element.index = index;
          });
        }
        if (this.sortValue === 'Created Date') {
          this.sortByDate();
        } else {
          this.sortByName();
        }
        this.showPromoContentName = promoContent.publishedName;
        this.page = 1;
        this.setIndex(1);
      },
        error => {
        }
      );
  }

  duplicatePromoContentImage(promoContent: any, newPromoContent: any, page: any) {
    return new Promise((resolve, reject) => {
      if (page.linkedAsset) {
        this.promoContentService.getPromoContentByPageId(promoContent.id, page.pageNum)
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(imageData => {
            this.promoContentService.putS3PromoContentByPageId(imageData, 'png', newPromoContent.id, page.pageNum) // Check how to get image type
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe((data) => {
                resolve(data);//ToDo: Need to add reject too.
              },
                error => {
                  // do something
                });
          },
            error => {
              // do something
            });
      } else {
        resolve({});//ToDo: just sending empty, to continue the flow;
      }
    });
  }

  deletePromoCG(promoCGID: string) {
    // delete Promo API call
    this.promoContentService.deletePromoContentById(promoCGID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(deleteResponse => {
        // console.log('Delete Store Promo success --', deleteResponse);
        const index = this.displayPromoContentGroups.findIndex(d => d.id === promoCGID); // find index in your array
        if (index >= 0) {
          this.displayPromoContentGroups.splice(index, 1); // remove element from array
        }
        this.closeModal(this.deleteModal);
      },
        error => {
          // do something
          // console.log('Delete Store Promo error --', error);
          this.closeModal(this.deleteModal);
        });
  }

  fontSizeNumber(size) {
    if (size === 'Small') { return 12; }
    if (size === 'Medium') { return 14; }
    if (size === 'Large') { return 16; }
  }

  getUILayoutNameByID(id) {// TODO - Confirm with Sujay if layout name is correct
    if (id === 1) {
      return '2_col_right_asset';
    } else if (id === 2) {
      return '2_col_left_asset';
    } else if (id === 3) {
      return '1_col_mid_asset';
    }
  }

  addPage() {
    const keyLen = Object.keys(this.pages).length;
    if (keyLen === 0) {
      this.pages.page1 = true;
      this.setIndex(2);
    } else if (keyLen === 1) {
      this.pages.page2 = true;
      this.setIndex(3);
    } else {
      this.pages.page3 = true;
      this.setIndex(4);
    }
    this.isPage3Created = this.checkPages();
    this.pagelen = Object.entries(this.pages).length;
  }

  checkPages() {
    if (this.pages.page1 && this.pages.page2 && this.pages.page3) {
      return true;
    }

    return false;
  }

  updatePromoContent() {
    const updatePromoContent: CreatePromoContentResponse = this.contentGrpData as CreatePromoContentResponse;
    // Once page is updated.
    const promoContent = updatePromoContent.promotionalContent;
    if (typeof promoContent.configurations !== 'string') {
      promoContent.configurations = JSON.stringify(promoContent.configurations);
    }
    this.promoContentService.putPromoContentById(JSON.stringify(promoContent), updatePromoContent.promotionalContent.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async (putPromoContentResponse: CreatePromoContentResponse) => {
        //  console.log('putPromoContentResponse:: ' + JSON.stringify(putPromoContentResponse));
        // Once the update call is successful, call a PUT call for the logo
        for (const each of this.mediaObjects) {
          if (each.uploaded) {
            await this.updateMedia(each);
          }
        }
        this.deviceExists = putPromoContentResponse.promotionalContent.deviceExists;

        if (this.presentPage === this.profilePage) {
          this.openModal(this.showModal);
        } else if (this.editCheck && this.presentPage === this.assetsPage && this.deviceExists) {
          this.openModal(this.applyModal);
        } else {
          this.pages = {};
          this.clickable = false;
          this.setIndex(0);
          this.getAllPromoContentsByUser();
        }
        this.gotoBackCreateProfile.emit();
      },
        error => {
        }
      );
  }

  updateMedia(each) {
    return new Promise((resolve, reject) => {
      this.promoContentService.putS3PromoContentByPageId(each.media.fileObj,
        each.media.name.split('.')
          .pop(), each.id, each.pageNum.toString())
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe((data) => {
          resolve(data);//To-Do: we should handle what if response code is other than 200
        },
          error => { // do something
          }
        );
    });
  }

  pushToSelectedGrps(ind: number) {
    this.selctedContGrpsForProfile.contentGrps.push({
      "promotionalContentId": this.displayPromoContentGroups[ind].id,
      "showOnDevice": this.displayPromoContentGroups[ind].showOnDevice
    });
  }

  // this function will be used in multiple places to set addToPackage, showOnDevice to true/false ---> for AddToProfile
  setPackageNshowOnDeviceVal(index: number, value: boolean) {
    this.displayPromoContentGroups[index].showOnDevice = this.displayPromoContentGroups[index].addToPackage = value;
  }

  // This function gets called when user selects/deselect show on device / addToPackage
  addToProfile(eventObj: any, index: number, eventSource: string) {
    // if or show on device
    if (eventSource === GlobalConstants.SHOW_ON_DEVICE) {
      if (eventObj.target.checked) {
        this.selctedContGrpsForProfile.showOnDevice.push(this.displayPromoContentGroups[index].id);
        const checkIndContentGrps = this.selctedContGrpsForProfile.contentGrps
          .findIndex(d => d.promotionalContentId === this.displayPromoContentGroups[index].id);
        this.selctedContGrpsForProfile.contentGrps[checkIndContentGrps].showOnDevice = true;
        this.displayPromoContentGroups[index].showOnDevice = true;
      } else {
        this.selctedContGrpsForProfile.showOnDevice = this.selctedContGrpsForProfile.showOnDevice
          .filter(item => item !== this.displayPromoContentGroups[index].id);
        const checkIndContentGrps = this.selctedContGrpsForProfile.contentGrps
          .findIndex(d => d.promotionalContentId === this.displayPromoContentGroups[index].id);
        this.selctedContGrpsForProfile.contentGrps[checkIndContentGrps].showOnDevice = false;
        this.displayPromoContentGroups[index].showOnDevice = false;
      }
    } else if (eventSource === GlobalConstants.ADD_TO_PACKAGE) { // for add to package
      if (eventObj.target.checked) {
        if (this.selctedContGrpsForProfile.contentGrps?.length <= 6) {
          this.displayPromoContentGroups[index].addToPackage = eventObj.target.checked;
          this.pushToSelectedGrps(index);
        } else {
          eventObj.target.checked = false;
        }
      } else {
        if (this.displayPromoContentGroups[index].showOnDevice) {
          this.selctedContGrpsForProfile.showOnDevice = this.selctedContGrpsForProfile.showOnDevice
            .filter(item => item !== this.displayPromoContentGroups[index].id);
        }
        this.setPackageNshowOnDeviceVal(index, false);
        const checkInd = this.selctedContGrpsForProfile.contentGrps
          .findIndex(d => d.promotionalContentId === this.displayPromoContentGroups[index].id);
        if (checkInd >= 0) {
          this.selctedContGrpsForProfile.contentGrps.splice(checkInd, 1);
        }
      }
    }
  }

  sendToProfile(action: string) {
    if (action === GlobalConstants.SEND) {
      if (!this.selctedContGrpsForProfile?.contentGrps?.length) {
        this.selctedContGrpsForProfile.contentGrps = [{
          'promotionalContentId': undefined,
          'showOnDevice': false,
        }];
      }
      this.cmnService.emitDataToProfile({ page: GlobalConstants.PROMO_CONTENT_GROUP, dataSet: this.selctedContGrpsForProfile.contentGrps });
      //gtm(google tag manager)
      window['dataLayer'].push({
        'promotional_content_added': true
      });
    } else {
      this.cmnService.emitDataToProfile({ page: GlobalConstants.PROMO_CONTENT_GROUP, dataSet: GlobalConstants.SKIP });
    }
    this.cmnService.scrollTopInitial();

  }

  redirectToList() {
    this.pages = {};
    this.clickable = false;
    this.setIndex(0);
    this.closeModal(this.showModal);
    // this.closeModal(this.applyModal)
    this.getAllPromoContentsByUser();
  }

  redirectToApplyList() {
    this.pages = {};
    this.clickable = false;
    this.closeModal(this.applyModal);
    this.setIndex(0);
    this.getAllPromoContentsByUser();
  }

  showOnDevice() {
    this.showDevice = true;
    this.redirectToList();
  }

  applyToDevice(applyDevice: boolean) {
    const updatePromoContent: CreatePromoContentResponse = this.contentGrpData as CreatePromoContentResponse;
    // Once page is updated.
    const promoContent = updatePromoContent.promotionalContent;
    if (typeof promoContent.configurations !== 'string') {
      promoContent.configurations = JSON.stringify(promoContent.configurations);
    }
    promoContent.ispushedToDevice = applyDevice;
    promoContent.showOnDevice = applyDevice;
    if (!applyDevice) {
      promoContent.deviceExists = false;
    }
    else {
      promoContent.deviceExists = this.deviceExists;
    }
    this.promoContentService.putPromoContentById(JSON.stringify(promoContent), updatePromoContent.promotionalContent.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async (putPromoContentResponse: CreatePromoContentResponse) => {
        this.redirectToApplyList();
      },
        error => {
        });
  }

  closeApplyDevice() {
    this.showDevice = false;
    this.redirectToApplyList();
  }

  closeShowOnDevice() {
    this.showDevice = false;
    this.redirectToList();
  }

  navigate() {
    this.isNavigated = true;
    this.newContentGrpDataToNavigate = this.contentGrpData;
    this.newContentGrpDataToNavigate.promotionalContent.configurations.formFactor =
      Utils.getFormFactorNames(this.newContentGrpDataToNavigate.promotionalContent.configurations.formFactor);
    if (
      this.newContentGrpDataToNavigate.promotionalContent &&
      this.newContentGrpDataToNavigate.promotionalContent.configurations
    ) {
      if (
        this.newContentGrpDataToNavigate.promotionalContent.configurations?.publishTime &&
        !this.newContentGrpDataToNavigate.promotionalContent.configurations.isPublishDateNow
      ) {
        //changing it to old format
        this.newContentGrpDataToNavigate.promotionalContent.configurations.publishTime = Utils.ChangetoOldFormat(
          this.newContentGrpDataToNavigate.promotionalContent.configurations.publishTime
        );
      }
      if (
        this.newContentGrpDataToNavigate.promotionalContent.configurations.expireTime &&
        this.newContentGrpDataToNavigate.promotionalContent.configurations.expireTime !== GlobalConstants.NEVER
      ) {
        //changing it to old format
        this.newContentGrpDataToNavigate.promotionalContent.configurations.expireTime = Utils.ChangetoOldFormat(
          this.newContentGrpDataToNavigate.promotionalContent.configurations.expireTime
        );
      }
    }
    this.dataService.setPromoContent(this.newContentGrpDataToNavigate.promotionalContent);
    this.setIndex(1);
    this.clickable = false;
  }

  tabTrimString(data: string) {
    return Utils.trimString(data)
  }

  getSelectedStoreData(data) {
    this.sendToStoreService.sendPromoToStoreService(this.promoContentIdInfo, data)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(sendToStoreResponse => {
        if (sendToStoreResponse['response-context'].statusCode === GlobalConstants.SUCCESS_RESPONSE_CODE) {
          this.isSendToStore = true;
        }
      });
  }

  disableFields() {
    this.cmnService.previewTypeObser
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(type => {
      this.previewType = type;
    });
    return this.previewType;
  }

  togglePreviewTabs(previewType, id) {
    this.isIdleExperienceEnabled = previewType;
    this.displayPromoContentGroups.forEach(element => {
      if (element.id === id) {
        element.isIdleExperienceEnabled = this.isIdleExperienceEnabled;
      }
    });
  }
  openPreviewPopup(modal) {
    this.previousSelectedTab = this.activePreviewTab;
    this.selectPreviewTab('Evo');
    this.modalService.open(modal);
  }

  closePromoModal() {
    if(this.modalService.hasOpenModals()) {
      this.selectPreviewTab(this.previousSelectedTab);
      this.modalService.dismissAll();
      this.previousSelectedTab = '';
    }
  }

  selectPreviewTab(selectedTab: string) {
    this.activePreviewTab = selectedTab;
  }
}
